export default __webpack_public_path__ + "static/media/ki.3fe8bdea.svg";